class LWKnop extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    this.shadowRoot.innerHTML = /* html */ `
      <style>
        /* De basisvorm: altijd grijs en rond */
        :host {
          display: inline-block;
        }
        
        button {
          padding: 10px 20px;
          border-radius: 25px;
          border: none;
          cursor: pointer;
          background-color: var(--knop-kleur, #ccc);
          font-weight: bold;
          transition: background 0.3s;
        }
        button:hover {
        cursor: pointer;
        background-color: black;
        color: white;
        }
      </style>
      
      <button>
        <slot></slot> </button>
    `;
  }
}
customElements.define('lw-knop', LWKnop);